import * as React from 'react';

/** Demotes the focusable flowbite Dropdown <ul> around `ref`, whose list role breaks the menu > item chain. */
export const useFlowbiteListDemotion = (ref: React.RefObject<Element>, enabled = true): void => {
    // Layout effect: the menu mounts open and AT may snapshot before a passive effect.
    React.useLayoutEffect(() => {
        if (!enabled) {
            return undefined;
        }

        const list = ref.current?.closest('ul');
        list?.setAttribute('role', 'none');
        // A focusable element keeps its implicit role.
        list?.removeAttribute('tabindex');

        // Only the last demoted item restores the list.
        return () => {
            if (list && !list.querySelector('li[role="none"]')) {
                list.removeAttribute('role');
                list.setAttribute('tabindex', '-1');
            }
        };
    }, [ref, enabled]);
};
